import { ProjectModel } from 'shared/domain/project/types/model';
import { isObjectIdString } from 'helpers/idComparison';
import {
  ISO6391LanguageCode,
  ISO6391LanguageCodes,
} from 'shared/types/locale';

function isStringArray(value: unknown): value is string[] {
  return (
    Array.isArray(value) && value.every((item) => typeof item === 'string')
  );
}

function isLocaleCode(value: unknown): value is ISO6391LanguageCode {
  return (
    typeof value === 'string' &&
    ISO6391LanguageCodes.includes(value as ISO6391LanguageCode)
  );
}

/**
 * Type guard for ProjectModel payloads on project broadcast channel.
 */
export function isProjectBroadcastModel(
  data: unknown
): data is ProjectModel {
  if (typeof data !== 'object' || data === null) {
    return false;
  }
  const candidate = data as Partial<ProjectModel>;
  return (
    isObjectIdString(candidate._id) &&
    typeof candidate.name === 'string' &&
    isObjectIdString(candidate.organizationId) &&
    typeof candidate.timezone === 'string' &&
    typeof candidate.currency === 'string' &&
    isLocaleCode(candidate.localeCode) &&
    isStringArray(candidate.processes) &&
    typeof candidate.deleted === 'boolean' &&
    typeof candidate.createdAt === 'string' &&
    typeof candidate.modifiedAt === 'string' &&
    (candidate.budget === undefined || typeof candidate.budget === 'number') &&
    (candidate.projectStartDate === undefined ||
      typeof candidate.projectStartDate === 'string') &&
    (candidate.projectEndDate === undefined ||
      typeof candidate.projectEndDate === 'string')
  );
}
